document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev',
            prevEl: '.swiper-next'
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

    // Reviews
    const sliderLeft = new Swiper('.reviews__slider-left', {
        effect: "fade",
        loop: true,
        slidesPerView: 1,
        allowTouchMove: true,
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            enabled: true,
            nextEl: '.reviews-next',
            prevEl: '.reviews-prev',
        },

    });

    const sliderMid = new Swiper('.reviews__slider-mid', {
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        slidesPerView: 1,

    });

    const sliderRight = new Swiper('.reviews__slider-right', {
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        slidesPerView: 1,
    });

    sliderLeft.controller.control = [sliderRight, sliderMid];

    // slider

           ////// Slider prev image
   let quadSliderPrev = new Swiper('.slider__slider',{
            loop: true,
            speed: 800,
            effect: 'fade',
            allowTouchMove: false,
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                prevEl: '.slider-prev',
                nextEl: '.slider-next'
            },
            on: {
                
            }
        });

        // document.querySelectorAll('.slider-prev, .slider-next').forEach((arrow)=>{
        //     arrow.addEventListener('click', ()=>{
        //         let src = document.querySelector('.swiper-slide-next .slider__image img').getAttribute('src');
        //         document.querySelector('.slider__float').classList.remove('show');
        //         setTimeout(() => {
        //             document.querySelector('.slider__float').classList.add('show');
        //             document.querySelector('.slider__float img').setAttribute('src', src);
        //         }, 100);
        //     });
        // });


    // carousel awards
    let carouselSliders = document.querySelectorAll('.swiper-carousel').forEach((carousel, i)=>{
        let entryId = carousel.getAttribute('data-entry');
        carousel.setAttribute(`data-item-swiper-${i}`, "");
        let sliderCarousel = new Swiper(`[data-item-swiper-${i}]`, {
            loop: true,
            speed: 700,
            slidesPerView: 1,
            spaceBetween: 30,
            centeredSlides: true,
            navigation: {
                nextEl: `.carousel-block-next-${entryId}`,
                prevEl: `.carousel-block-prev-${entryId}`,
            },
             breakpoints: {
                700: {
                    slidesPerView: 2,
                },
                950: {
                    slidesPerView: 3,
                }
            }
        });
    })

    // slider two image

    let textSlider = new Swiper('.slider-dual__texts', {
        loop: true,
        effect: 'fade',
        speed: 800,
        allowTouchMove: false,
        fadeEffect: { crossFade: true }
    });

    let imageSlider = new Swiper('.slider-dual__images', {
        loop: true,
        speed: 800,
        slidesPerView: 2,
        spaceBetween: 30,
        centeredSlides: false,
        grabCursor: true,
        navigation: {
            prevEl: '.slider-dual-next',
            nextEl: '.slider-dual-prev'
        }
    });

    imageSlider.on('slideChange', () => {
        textSlider.slideToLoop(imageSlider.realIndex);
    });

});

